<template>
  <v-layout
    row
    wrap
    align-center
    class="mb-4"
  >
    <!-- LEFT LABEL (same width as other fields) -->
    <v-flex
      xs12
      sm4
      class="text-left"
    >
      Consent Form:
    </v-flex>

    <!-- RIGHT CONTENT (same alignment as inputs) -->
    <v-flex
      xs12
      sm8
    >
      <div class="consent-actions">
        <!-- DOWNLOAD LINK -->
        <a
          :href="url"
          target="_blank"
          class="consent-link"
        >
          Download Consent Form (PDF)
        </a>
      </div>

      <div class="consent-hint">
        Download, sign, and upload the consent form (PDF only)
        <v-btn
          icon
          small
          color="primary"
          class="ml-1"
          @click.stop="emitHelp"
        >
          <v-icon small>
            help_outline
          </v-icon>
        </v-btn>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'ConsentFormDownload',
  props: {
    url: {
      type: String,
      required: true,
    },
    helpLabel: {
      type: String,
      default: null,
    },
  },
  methods: {
    emitHelp () {
      this.$root.$emit('help-click', {
        fieldKey: 'consentLetterDownload',
      })
    },
  },
}
</script>

<style scoped>
.consent-link {
  color: #1976d2;
  text-decoration: underline;
  display: inline-block;
}

.consent-hint {
  font-size: 12px;
  color: #aaa;
  display: flex;
  align-items: center;
}

.consent-actions {
  display: flex;
  align-items: center;
}

.consent-help {
  padding: 0;
  min-width: auto;
}

</style>
